// @file Network requests related to user integrations from surface

import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { GoogleDriveAuthorizationResult, MicrosoftOneDriveAuthorizationResult, UserId } from '@@/types'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

class UserIntegrationsApi extends FetchableObject {
  public static async fetchGoogleDriveAuthorization(
    id: UserId,
    fetchOptions = { apiVersion: 1 },
  ): Promise<JsonAPIResponse<GoogleDriveAuthorizationResult>> {
    const { apiVersion } = fetchOptions
    return await fetchJson(`/api/${apiVersion}/user/${id}/user_integrations/google_drive`, {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  public static async refreshGoogleDriveAccessToken(
    id: UserId,
    fetchOptions = {},
  ): Promise<JsonAPIResponse<GoogleDriveAuthorizationResult>> {
    return await fetchJson(`/api/1/user/${id}/user_integrations/google_drive/refresh_access_token`, {
      method: HTTPMethod.post,
      ...fetchOptions,
    })
  }

  public static async fetchMicrosoftOneDriveAuthorization(
    id: UserId,
    fetchOptions = { apiVersion: 1 },
  ): Promise<JsonAPIResponse<MicrosoftOneDriveAuthorizationResult>> {
    const { apiVersion } = fetchOptions
    return await fetchJson(`/api/${apiVersion}/user/${id}/user-integrations/microsoft-onedrive`, {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  public static async refreshMicrosoftOneDriveAccessToken(
    id: UserId,
    fetchOptions = {},
  ): Promise<JsonAPIResponse<MicrosoftOneDriveAuthorizationResult>> {
    return await fetchJson(`/api/1/user/${id}/user-integrations/microsoft-onedrive/refresh-access-token`, {
      method: HTTPMethod.post,
      ...fetchOptions,
    })
  }
}

export { UserIntegrationsApi }
